<ui-notification
  [uuid]="uuid()"
  [duration]="customDuration()"
  color="success"
  data-track="location-edit-success-notification"
>
  <ng-icon name="heroCheckCircle" size="24" class="!block size-6" slot="icon" />
  <p class="text-sm font-medium text-on-surface dark:text-on-surface-darkmode">
    {{ 'cockpit.locations.details.notifications.editSuccess.title' | transloco }}
  </p>
  <p class="mt-1 text-sm text-on-surface-subtle dark:text-on-surface-subtle-darkmode">
    {{ 'cockpit.locations.details.notifications.editSuccess.subtitle' | transloco }}
  </p>
  <div class="mt-3 flex gap-1">
    <ui-button
      size="small"
      mode="outlined"
      (click)="onClickUndo()"
      [loading]="loading()"
      data-track="location-edit-undo-button"
    >
      {{ 'cockpit.locations.details.notifications.editSuccess.undo' | transloco }}
    </ui-button>
    <ui-button
      size="small"
      mode="ghost"
      (click)="notification()?.dismiss()"
      data-track="location-edit-dismiss-button"
    >
      {{ 'cockpit.locations.details.notifications.editSuccess.dismiss' | transloco }}
    </ui-button>
  </div>
</ui-notification>
